// Copyright (c) 2020, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import { Query, Mutation } from 'react-apollo'
import * as Sentry from '@sentry/browser'

import {
  Button,
  SvgIcon
} from '../'

import { QUERY_REQUESTTYPE } from '../../queries'
import { MUTATION_REQUESTRUN } from '../../mutations'


export class ButtonRequestRunInitiate extends Component {
  static propTypes = {
    requestTypeId: PropTypes.string.isRequired,
    identityId: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
    onInitiateTriggered: PropTypes.func,
    onInitiateDone: PropTypes.func,
    autoInitiateWorkflowRun: PropTypes.bool,
    requestContentCaptureOnInitiate: PropTypes.object,
    origin: PropTypes.string,
    buttonType: PropTypes.oneOf(["reset", "brand", "destructive", "inverse", "default"]),
    minWidth: PropTypes.number,
    className: PropTypes.string
  }

  static defaultProps = {
    type: 'brand',
    className: '',
    autoInitiateWorkflowRun: false,
    origin: 'form'
  }

  initiate = (requestType, requestrunMutate) => {
    const { identityId, onInitiateTriggered, onInitiateDone, origin } = this.props

    if (onInitiateTriggered) {
      onInitiateTriggered()
    }

    const input = {
      requesttype: requestType.id,
      identity: identityId,
      version: requestType.version,
      origin
    }

    if (this.props.requestContentCaptureOnInitiate) {
      let content = JSON.parse(requestType.content)

      Object.keys(this.props.requestContentCaptureOnInitiate).forEach(field => (
        content[field].value = this.props.requestContentCaptureOnInitiate[field]
      ))

      input.content = JSON.stringify(content)
      input.capturedBy = localStorage.getItem('userNodeId')
    }

    return requestrunMutate({ variables: { input } })
      .then(({ data }) => {
        let requestRun = data.requestrunMutate.requestrun
        if (this.props.autoInitiateWorkflowRun) {
          requestrunMutate({
            variables: {
              input: {
                id: requestRun.id,
                methodCall: "initiate_awaiting_workflowrun"
              }
            }
          })
          .then(() => console.info('Workflow run initiated'))
          .catch(error => console.error('Workflow run initiation failed.'))
        }
        onInitiateDone(requestRun.id)
      })
      .catch(error => {
        Sentry.captureMessage(`Failed to initiate verification request - ${error}`)
        onInitiateDone()
      })
  }

  render() {
    const { requestTypeId, disabled, buttonType, minWidth, children, className } = this.props

    return (
      <Query query={QUERY_REQUESTTYPE} variables={{ id: requestTypeId }}>
        {({ loading, error, data }) => {
          if (loading || error || !data.requesttype) {
            return (
              <Button disabled={true}>
                <SvgIcon
                  variant='utility'
                  symbol='warning'
                  colour='error'
                  size='x-small'
                />
              </Button>
            )
          }

          const requestType = data.requesttype

          return (
            <Mutation mutation={MUTATION_REQUESTRUN}>
              {(requestrunMutate, { data }) => (
                <Button
                  type={buttonType}
                  onClick={() => this.initiate(requestType, requestrunMutate)}
                  disabled={disabled}
                  minWidth={minWidth}
                  className={className}>
                  {children}
                </Button>
              )}
            </Mutation>
          )
        }}
      </Query>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/button-requestrun-initiate/index.js